/* eslint-disable react/prop-types */
import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';
import { get } from 'lodash';
import InvoiceTableHeader from './InvoiceTableHeader';
import InvoiceTableRow from './InvoiceTableRow';
import InvoiceTableFooter from './InvoiceTableFooter';

const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 24,
    borderWidth: 1,
    borderColor: '#3778C2',
  },
});

function InvoiceItemsTable({ dados }) {
  return (
    <View style={styles.tableContainer}>
      <InvoiceTableHeader />
      <InvoiceTableRow items={get(dados, 'Receita', [])} />
      <InvoiceTableFooter items={get(dados, 'Receita', [])} />
    </View>
  );
}

export default InvoiceItemsTable;
